import { Component, Input, Output, EventEmitter, OnInit, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogService } from './dialog.service';

@Component({
    selector: 'app-dialog',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './dialog.component.html',
})
export class DialogComponent implements OnInit, OnDestroy, OnChanges {
    @Input() title: string = '';
    @Input() size: 'sm' | 'md' | 'lg' | 'xl' | '2xl' = 'md';
    @Input() show: boolean = false;
    @Input() position: 'right' | 'center' = 'center';
    @Input() showHeader: boolean = false;
    @Output() close = new EventEmitter<void>();

    constructor(private readonly dialogService: DialogService) {}

    ngOnInit() {
        if (this.show) {
            this.dialogService.setDialogOpen(true);
        }
    }

    ngOnDestroy() {
        this.dialogService.setDialogOpen(false);
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['show']) {
            this.dialogService.setDialogOpen(this.show);
        }
    }

    get dialogSizeClass() {
        // Custom widths for breakpoints
        return [
            'w-full',
            'max-w-[95vw]',
            'sm:max-w-[400px]', // ~640px
            'md:max-w-[440px]', // ~768px
            'lg:max-w-[480px]', // ~1024px
            'xl:max-w-[520px]', // ~1280px
            'max-w-[360px] xl:max-w-[520px] lg:max-w-[480px] md:max-w-[440px] sm:max-w-[400px]'
        ].join(' ');
    }

    onShowChange(show: boolean) {
        this.dialogService.setDialogOpen(show);
    }

    onClose() {
        this.close.emit();
    }
} 